import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { NumField } from "@/components/NumField";

export const BookDialog = ({ open, onOpenChange, book, onSaved }) => {
  const [name, setName] = useState("");
  const [ob, setOb] = useState("");
  const [fz, setFz] = useState("");
  const [sob, setSob] = useState("");
  const [sfz, setSfz] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setName(book?.name || "");
    setOb(book ? String(book.opening_balance) : "");
    setFz(book ? String(book.opening_freeze) : "");
    setSob(book ? String(book.sett_opening_balance ?? 0) : "");
    setSfz(book ? String(book.sett_opening_freeze ?? 0) : "");
  }, [open, book]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = { name: name.trim(), opening_balance: Number(ob) || 0, opening_freeze: Number(fz) || 0,
        sett_opening_balance: Number(sob) || 0, sett_opening_freeze: Number(sfz) || 0 };
      const { data } = book ? await api.put(`/books/${book.id}`, body) : await api.post("/books", body);
      toast.success(book ? "Book updated" : "Book created");
      onSaved(data);
      onOpenChange(false);
    } catch (ex) {
      toast.error(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none sm:rounded-none max-w-md" data-testid="book-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold tracking-tight">{book ? "Edit book" : "New book"}</DialogTitle>
          <DialogDescription>The opening balances are where the first entry starts from.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <label className="block">
            <span className="text-[11px] font-semibold uppercase tracking-[0.15em] text-slate-500">Book name</span>
            <input data-testid="book-name-input" required maxLength={80} value={name} onChange={(e) => setName(e.target.value)}
              placeholder="e.g. NEW DREAM 2"
              className="mt-1.5 w-full h-12 px-3 border border-slate-300 outline-none focus:border-slate-900 uppercase font-semibold" />
          </label>
          <div className="grid grid-cols-2 gap-3">
            <NumField label="Opening balance" value={ob} onChange={setOb} testId="book-opening-balance-input" />
            <NumField label="Opening freeze bal" value={fz} onChange={setFz} testId="book-opening-freeze-input" />
            <NumField label="Sett. opening bal" value={sob} onChange={setSob} testId="book-sett-opening-balance-input" />
            <NumField label="Sett. opening freeze" value={sfz} onChange={setSfz} testId="book-sett-opening-freeze-input" />
          </div>
          <button data-testid="save-book-btn" disabled={busy}
            className="w-full h-12 bg-slate-900 text-white font-semibold hover:bg-slate-800 transition-colors disabled:opacity-60">
            {busy ? "Saving…" : book ? "Save changes" : "Create book"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
